/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PluginAssignment,
  PluginAssignment$inboundSchema,
} from "./pluginassignment.js";

export type SetPluginAssignmentsResponseBody = {
  /**
   * The updated assignments.
   */
  assignments: Array<PluginAssignment>;
};

/** @internal */
export const SetPluginAssignmentsResponseBody$inboundSchema: z.ZodMiniType<
  SetPluginAssignmentsResponseBody,
  unknown
> = z.object({
  assignments: z.array(PluginAssignment$inboundSchema),
});

export function setPluginAssignmentsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<SetPluginAssignmentsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SetPluginAssignmentsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SetPluginAssignmentsResponseBody' from JSON`,
  );
}
